import logo from './logo.svg';
import './App.css';
import MarketingPage from './landingpage/MarketingPage';
import Dashboard from './modules/dashboard/Dashboard';
import OnBoardingLayout from './layouts/OnBoarding';
import LoginLayout from './layouts/Login';
import AlmacenesPage from './modules/logistica/almacenes';
import AlmacenDetails from './modules/logistica/almacenes/almacenDetails';
import ProductosCategoria from './modules/logistica/categorias';
import Productos from './modules/logistica/productos';
import ProductDetail from './modules/logistica/productos/productDetail';
import TallerServicios from './modules/logistica/taller';
import ListasDePrecios from './modules/logistica/listaprecios';
import ListaDetallePage from './modules/logistica/listaprecios/listadetallepage';
import ModuloCompras from './modules/logistica/compras';
import OrdenCompraDetail from './modules/logistica/compras/ordenescompra/ordencompradetail';
import ProveedorDetails from './modules/logistica/compras/proveedores/proveedordetail';
import CrearFacturaProveedor from './modules/logistica/compras/facturasproveedores/crearfacturaproveedor';
import EditarFacturaProveedor from './modules/logistica/compras/facturasproveedores/editarfacturaproveedor';
import AgregarPago from './modules/logistica/compras/pagos/agregarpago';
import PagoDetails from './modules/logistica/compras/pagos/pagodetails';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SessionManager from './components/SessionManager';
import FinancialProducts from './modules/gestion_comercial/productos_financieros';
import Crearnuevoproductofinan from './modules/gestion_comercial/productos_financieros/crearnuevoproductofinan';
import ProdFinancieroDetalle from './modules/gestion_comercial/productos_financieros/prodfinancierodetalle';
import LoansManagement from './modules/gestion_comercial/prestamos';
import CrearPrestamo from './modules/gestion_comercial/prestamos/crearprestamo';
import DetalleSolicitud from './modules/gestion_comercial/prestamos/solicitudes/detallesolicitud';
import DetallePrestamo from './modules/gestion_comercial/prestamos/detalleprestamo';
import PromesasPago from './modules/gestion_comercial/prestamos/promesas_pago';
import TransferenciasMercancia from './modules/logistica/transferencias';
import CrearTransferencia from './modules/logistica/transferencias/creartransferencia';
import DetalleTransferencia from './modules/logistica/transferencias/detalletransferencia';
import BillingScreen from './modules/gestion_comercial/centro_cobros';
import CategoriasCargos from './modules/gestion_comercial/categorias_cargos';
import GestionComercialCargos from './modules/gestion_comercial/categorias_cargos/cargo/gestion_comercial';
import Recuperacion from './modules/gestion_comercial/recuperacion';
import LoanTransferModule from './modules/gestion_comercial/traspaso';
import LoanPortfoliosPage from './modules/gestion_comercial/portafolio';
import PortafolioDetailsPage from './modules/gestion_comercial/portafolio/detalle';
import HistorialTurnos from './modules/gestion_comercial/centro_cobros/gestion_turnos/historialturnos';
import Clientes from './modules/gestion_comercial/centro_cobros/clientes';
import Configuracion from './modules/configuracion';
import AntiguedadSaldoReport from './modules/gestion_comercial/prestamos/reportes/antiguedadsaldo';
import BalanceDePrestamosReport from './modules/gestion_comercial/prestamos/reportes/balancedeprestamos';
import InteresesCobradosPorPeriodosReport from './modules/gestion_comercial/prestamos/reportes/interesescobradosperiodo';
import VentasReport from './modules/gestion_comercial/ventas.js'
import CuadreDeCajaReport from './modules/gestion_comercial/ventas.js/cuadredecaja'
import CuadreDeCajaPrestamosReport from './modules/gestion_comercial/prestamos/reportes/cuadredecaja'
import HistorialProductoReport from './modules/gestion_comercial/prestamos/reportes/historialproducto'
import SubscriptionPlans from './modules/configuracion/components/SubscriptionPlans'
import GlobalTourProvider from './components/GlobalTourProvider';
import Hotjar from '@hotjar/browser';
import mixpanel from "mixpanel-browser";
import GastosManagement from './modules/gestion_comercial/centro_cobros/gastos';
import CobrosMovilesManagement from './modules/gestion_comercial/cobros_moviles';
import RutaDetail from './modules/gestion_comercial/cobros_moviles/rutas/rutadetail';
import RendimientoReportes from './modules/gestion_comercial/cobros_moviles/reportes/rendimiento';
import MapaCobradores from './modules/gestion_comercial/cobros_moviles/mapa';
import Inversionistas from './modules/gestion_comercial/inversionistas';
import DetalleInversionista from './modules/gestion_comercial/inversionistas/DetalleInversionista';
import RequirePermission from './components/RequirePermission';





function App() {
  const siteId = 6507764;
  const hotjarVersion = 6;
  mixpanel.init('9dfe59d336d2534f63351f763bcae1b7', {
    autocapture: true,
    record_sessions_percent: 100,
  })


  Hotjar.init(siteId, hotjarVersion);
  return (
    <div className="App">
      
       <Router>
         <SessionManager>
         <GlobalTourProvider>
          <Routes>
            <Route path="/" element={<MarketingPage />} />
            <Route path="/dashboard" element={<Dashboard/>} />
            <Route path="/onBoarding" element={<OnBoardingLayout/>} />
            <Route path="/login" element={<LoginLayout />} />
            <Route path="/logistica/almacenes" element={
              <RequirePermission modulo="almacenes" accion="ver">
                <AlmacenesPage />
              </RequirePermission>
            } />
            <Route path='/logistica/almacenes/:id' element={
              <RequirePermission modulo="almacenes" accion="ver">
                <AlmacenDetails/>
              </RequirePermission>
            }/>
            <Route path='/logistica/categorias' element={
              <RequirePermission modulo="categorias_inventario" accion="ver">
                <ProductosCategoria/>
              </RequirePermission>
            }/>
            <Route path='/logistica/productos' element={
              <RequirePermission modulo="productos" accion="ver">
                <Productos/>
              </RequirePermission>
            }/>
            <Route path='/logistica/productos/:id' element={
              <RequirePermission modulo="productos" accion="ver">
                <ProductDetail/>
              </RequirePermission>
            }/>
            <Route path='/logistica/Listasdeprecios' element={
              <RequirePermission modulo="lista_precios" accion="ver">
                <ListasDePrecios/>
              </RequirePermission>
            }/>
            <Route path='/logistica/Listasdeprecios/:id' element={
              <RequirePermission modulo="lista_precios" accion="ver">
                <ListaDetallePage/>
              </RequirePermission>
            }/>
            <Route path='/logistica/Centrodeservicios' element={<TallerServicios/>}/>
            <Route path='/logistica/transferencias' element={<TransferenciasMercancia/>}/>
            <Route path='/logistica/transferencias/crear' element={<CrearTransferencia/>}/>
            <Route path='/logistica/transferencias/detalle/:id' element={<DetalleTransferencia/>}/>
            <Route path='/logistica/compras' element={<ModuloCompras/>}/>
            <Route path='/logistica/compras/proveedores/:id' element={<ProveedorDetails/>}/>
            <Route path='/logistica/compras/ordenes-compra/:id' element={<OrdenCompraDetail/>}/>
            <Route path='/logistica/compras/facturas-proveedor/crear' element={<CrearFacturaProveedor/>}/>
            <Route path='/logistica/compras/facturas-proveedor/editar/:id' element={<EditarFacturaProveedor/>}/>
            <Route path='/logistica/compras/pagos/agregar' element={<AgregarPago/>}/>
            <Route path='/logistica/compras/pagos/:id' element={<PagoDetails/>}/>


            {/* gestion comercial */}
            <Route path='/gestion_comercial/productos_financieros' element={
              <RequirePermission modulo="productos_financieros" accion="ver">
                <FinancialProducts/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/productos_financieros/crear' element={
              <RequirePermission modulo="productos_financieros" accion="crear">
                <Crearnuevoproductofinan/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/productos_financieros/detalle/:id' element={
              <RequirePermission modulo="productos_financieros" accion="ver">
                <ProdFinancieroDetalle/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos' element={
              <RequirePermission modulo="prestamos" accion="ver">
                <LoansManagement/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/crear' element={
              <RequirePermission modulo="prestamos" accion="crear">
                <CrearPrestamo/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/solicitudes/detalle/:id' element={
              <RequirePermission modulo="prestamos" accion="ver">
                <DetalleSolicitud/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/detalle/:id' element={
              <RequirePermission modulo="prestamos" accion="ver">
                <DetallePrestamo/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/promesas_pago' element={
              <RequirePermission modulo="prestamos" accion="ver">
                <PromesasPago/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/centro_cobros' element={
              <RequirePermission modulo="pagos" accion="ver">
                <BillingScreen/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/categorias_cargos' element={
              <RequirePermission modulo="categorias_cargos" accion="ver">
                <CategoriasCargos/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/:id' element={<GestionComercialCargos/>}/>
            <Route path='/gestion_comercial/recuperacion' element={
              <RequirePermission modulo="recuperaciones" accion="ver">
                <Recuperacion/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/traspaso' element={
              <RequirePermission modulo="traspaso" accion="ver">
                <LoanTransferModule/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/portafolio' element={
              <RequirePermission modulo="portafolio" accion="ver">
                <LoanPortfoliosPage/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/portafolio/detalle/:id' element={
              <RequirePermission modulo="portafolio" accion="ver">
                <PortafolioDetailsPage/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/ventas' element={<VentasReport/>}/>
            <Route path='/gestion_comercial/ventas/cuadre' element={<CuadreDeCajaReport/>}/>
            <Route path='/gestion_comercial/inversionistas' element={<Inversionistas/>}/>
            <Route path='/gestion_comercial/inversionistas/detalle/:id' element={<DetalleInversionista/>}/>  

            {/* gestion comercial prestamos */}
            <Route path='/gestion_comercial/prestamos/reportes/antiguedadsaldo' element={
              <RequirePermission modulo="reportes" accion="ver">
                <AntiguedadSaldoReport/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/reportes/balancedeprestamos' element={
              <RequirePermission modulo="reportes" accion="ver">
                <BalanceDePrestamosReport/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/reportes/interesescobradosperiodo' element={
              <RequirePermission modulo="reportes" accion="ver">
                <InteresesCobradosPorPeriodosReport/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/reportes/cuadredecajaprestamos' element={
              <RequirePermission modulo="reportes" accion="ver">
                <CuadreDeCajaPrestamosReport/>
              </RequirePermission>
            }/>
            <Route path='/gestion_comercial/prestamos/reportes/historialproducto' element={
              <RequirePermission modulo="reportes" accion="ver">
                <HistorialProductoReport/>
              </RequirePermission>
            }/>
            {/* gestion comercial centro de cobros */}
            <Route path='/gestion_comercial/centro_cobros/gestion_turnos/historialturnos' element={<HistorialTurnos/>}/>  
            <Route path='/gestion_comercial/centro_cobros/clientes' element={<Clientes/>}/>
            <Route path='/gestion_comercial/centro_cobros/gastos' element={<GastosManagement/>}/>
            
                  {/* cobros moviles */}
                  <Route path='/gestion_comercial/cobros_moviles' element={<CobrosMovilesManagement/>}/>
                  <Route path='/gestion_comercial/cobros_moviles/rutas/:id' element={<RutaDetail/>}/>
                  <Route path='/gestion_comercial/cobros_moviles/reportes' element={<RendimientoReportes/>}/>
                  <Route path='/gestion_comercial/cobros_moviles/mapa' element={<MapaCobradores/>}/>

            {/* configuracion */}
            <Route path='/settings' element={<Configuracion/>}/>
            <Route path='/configuracion/subscription-plans' element={<SubscriptionPlans/>}/>  
          </Routes>
        </GlobalTourProvider>
        </SessionManager>
        </Router>
    {/* Tawk Messenger temporarily disabled due to Redux compatibility issues */}
    {/* <TawkMessengerReact
      propertyId="68d8310ef3043f1954464361"
      widgetId="1j667v8p8"
    /> */}
    </div>
  );
}

export default App;
